import { render, staticRenderFns } from "./EditApp.vue?vue&type=template&id=3f95d8e0&"
import script from "./EditApp.vue?vue&type=script&lang=ts&"
export * from "./EditApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports